import { useQuery } from '@tanstack/react-query';
import { api } from '../../services/api';
import { CheckStockBodyDto, StockDto } from '../../services/stock';

export const getAssemblyStockWithoutGranit = async (
  body?: CheckStockBodyDto,
): Promise<StockDto[] | undefined> => {
  if (!body) {
    return undefined;
  }
  const { data } = await api.post<StockDto[]>(`/stock/check/assembly`, body);
  return data;
};

export const useAssemblyStockWithoutGranit = (body?: CheckStockBodyDto) => {
  return useQuery({
    queryKey: ['assembly-stock-without-granit', body],
    queryFn: () => getAssemblyStockWithoutGranit(body),
    retry: false,
    enabled: !!body,
  });
};
